import { ReactElement } from "react";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import IndicatorGauge from "../../../../components/Shared/IndicatorGauge";
import StatusIndicator from "../../../../components/Shared/StatusIndicator";
import styles from "./MainIndicator.module.scss";

interface MainIndicatorProps
{
    component: IComponent;
}

const MainIndicator = (props: MainIndicatorProps): ReactElement =>
{
    return (
        <div className={styles.mainIndicator}>
            <div className={styles.healthGauge}>
                <IndicatorGauge
                    score={props.component?.healthIndicatorScore}
                    status={props.component?.healthIndicatorStatusId}
                />
            </div>

            <div>
                <span className={styles.scoreTitle}>{props.component?.healthIndicatorName}</span>

                {props.component?.healthIndicatorScore && (
                    <StatusIndicator
                        component={props.component}
                        customClassName={styles.scoreNumber}
                        hideDot
                        inverted
                    />
                )}
            </div>
        </div>
    );
};

export default MainIndicator;
